import { render, staticRenderFns } from "./GestionHidrocarburosCambios.vue?vue&type=template&id=88889c48"
import script from "./GestionHidrocarburosCambios.vue?vue&type=script&lang=js"
export * from "./GestionHidrocarburosCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports